export default __webpack_public_path__ + "static/media/icon-network-bitcoin_cash.538cea00.svg";